import { ChangeDetectionStrategy, Component, Injector, Input, OnInit } from '@angular/core';

import { Widget } from '../../../models/form-widget.model';
import { WidgetBase } from '../../../models/widget-base';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenToDivPipe } from '../../../helpers/token-to-div.pipe';

@Component({
  selector: 'app-fb-text',
  templateUrl: './fb-text.component.html',
  styleUrls: ['./fb-text.component.scss'],
  imports: [CommonModule, FormsModule, TokenToDivPipe],
  // WARNING: DO NOT ENABLE OnPush STRATEGY ON CHILD WIDGETS
})
export class FbTextComponent extends WidgetBase implements OnInit {
  @Input() public override set payload(value) {
    this._payload = value;
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}
}
